import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import PalletsEdit from '../../components/pallets/Pallets/PalletsEdit';

export default function PalletsPageEdit( props ){
    //console.debug("RTS Break PalletsPageEdit");

    useEffect(() => {
        props.setIsModalFx(true);
    }, [props]); 

    return(
        <Container component="main" maxWidth="sm" sx={{mb:5}}>
            <CssBaseline />
            <Typography variant="h5" sx={{my:2}}>Edit Pallet</Typography>
            <Box>
                <PalletsEdit />
            </Box>
        </Container>
    );
}
